(function () {
  if (window.__mrShishaFreeGiftLoaded) return;
  window.__mrShishaFreeGiftLoaded = true;

  var internalRequest = false;
  var syncPromise = null;
  var syncTimer = null;
  var originalFetch = window.fetch.bind(window);

  function config() {
    var source = window.MrShishaFreeGiftConfig || {};
    return {
      enabled: source.enabled === true,
      threshold: Math.max(0, Number(source.threshold) || 0),
      variantId: Number(source.variantId) || 0,
      discountCode: String(source.discountCode || '').trim(),
      label: String(source.label || 'Regalo por tu compra')
    };
  }

  function routes() {
    var root = window.theme && theme.routes && theme.routes.root_url || '/';
    if (root.slice(-1) !== '/') root += '/';
    return {
      cart: root + 'cart.js',
      add: root + 'cart/add.js',
      update: root + 'cart/update.js'
    };
  }

  function isGift(item) {
    return Boolean(item && item.properties && item.properties._mrshisha_free_gift === 'true');
  }

  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (subtotal, item) {
      return isGift(item) ? subtotal : subtotal + Number(item.original_line_price || 0);
    }, 0);
  }

  function sameCodes(left, right) {
    var a = left.map(function (code) { return code.toLowerCase(); }).sort();
    var b = right.map(function (code) { return code.toLowerCase(); }).sort();
    return a.length === b.length && a.every(function (code, index) { return code === b[index]; });
  }

  async function request(url, payload) {
    var options = { headers: { Accept: 'application/json' } };
    if (payload !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    var response = await originalFetch(url, options);
    if (!response.ok) {
      var error = await response.json().catch(function () { return {}; });
      throw new Error(error.description || error.message || 'No se pudo actualizar el regalo');
    }
    return response.json();
  }

  async function performSync() {
    var gift = config();
    var urls = routes();
    var cart = await request(urls.cart);
    var giftLines = (cart.items || []).filter(isGift);
    var previousGiftCodes = giftLines.map(function (item) {
      return item.properties._mrshisha_free_gift_discount_code;
    }).filter(Boolean);
    var qualifies = gift.enabled && gift.threshold > 0 && gift.variantId > 0 && gift.discountCode && qualifyingSubtotal(cart) >= gift.threshold;
    var matchingLine = giftLines.find(function (item) {
      return Number(item.variant_id) === gift.variantId;
    });
    var updates = {};
    var changed = false;

    giftLines.forEach(function (item) {
      var keep = qualifies && item === matchingLine;
      var desiredQuantity = keep ? 1 : 0;
      if (Number(item.quantity) !== desiredQuantity) {
        updates[item.key] = desiredQuantity;
        changed = true;
      }
    });

    if (Object.keys(updates).length) {
      cart = await request(urls.update, { updates: updates });
    }

    if (qualifies && !matchingLine) {
      try {
        cart = await request(urls.add, {
          items: [{
            id: gift.variantId,
            quantity: 1,
            properties: {
              _mrshisha_free_gift: 'true',
              _mrshisha_free_gift_label: gift.label,
              _mrshisha_free_gift_discount_code: gift.discountCode
            }
          }]
        });
        changed = true;
      } catch (error) {
        qualifies = false;
        console.warn('El producto de regalo no está disponible.', error);
      }
    }

    cart = await request(urls.cart);
    var giftIsPresent = (cart.items || []).some(function (item) {
      return isGift(item) && Number(item.variant_id) === gift.variantId;
    });
    var campaignCodes = [gift.discountCode].concat(previousGiftCodes).concat((cart.items || []).map(function (item) {
      return isGift(item) ? item.properties._mrshisha_free_gift_discount_code : '';
    })).filter(Boolean);
    var existingCodes = (cart.discount_codes || []).map(function (discount) { return discount.code; }).filter(Boolean);
    var customerCodes = existingCodes.filter(function (code) {
      return !campaignCodes.some(function (campaignCode) {
        return campaignCode.toLowerCase() === code.toLowerCase();
      });
    });
    var desiredCodes = qualifies && giftIsPresent ? customerCodes.concat(gift.discountCode) : customerCodes;

    if (!sameCodes(existingCodes, desiredCodes)) {
      cart = await request(urls.update, { discount: desiredCodes.join(',') });
      changed = true;
    }

    return { cart: cart, changed: changed };
  }

  function refreshCartSurfaces(cart) {
    document.querySelectorAll('cart-count').forEach(function (counter) {
      counter.textContent = cart.item_count;
      counter.toggleAttribute('hidden', cart.item_count === 0);
    });

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));

    var mainCart = document.querySelector('main-cart[data-section-id]');
    if (!mainCart) return;
    var sectionId = mainCart.getAttribute('data-section-id');
    var separator = window.location.search ? '&' : '?';
    originalFetch(window.location.pathname + window.location.search + separator + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.getElementById('MainCart-' + sectionId);
        var current = document.getElementById('MainCart-' + sectionId);
        if (replacement && current) current.innerHTML = replacement.innerHTML;
      })
      .catch(function () {});
  }

  function sync() {
    if (syncPromise) return syncPromise;
    internalRequest = true;
    syncPromise = performSync()
      .then(function (result) {
        if (result.changed) refreshCartSurfaces(result.cart);
        return result.cart;
      })
      .catch(function (error) {
        console.error('No se pudo sincronizar el regalo automático.', error);
        return null;
      })
      .finally(function () {
        internalRequest = false;
        syncPromise = null;
      });
    return syncPromise;
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 120);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url || '';
    var isMutation = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
    var response = originalFetch(input, init);
    if (isMutation && !internalRequest) {
      response.then(function (result) {
        if (result.ok || result.status === 422) scheduleSync();
      }).catch(function () {});
    }
    return response;
  };

  document.addEventListener('DOMContentLoaded', sync, { once: true });
  document.addEventListener('cart:updated', scheduleSync);
  window.MrShishaFreeGift = { sync: sync };
})();
